export const ConversationEventActions = {
    ConversationRenamed: "ConversationRenamed",
    ConversationDeleted: "ConversationDeleted",
    ConversationSearchResultSelected: "ConversationSearchResultSelected",
    BookViewHistoryCleared: "BookViewHistoryCleared",
    ConversationContextChipClicked: "ConversationContextChipClicked",
} as const;

export const MessageEventActions = {
    MessageSent: "MessageSent",
    MessageEdited: "MessageEdited",
    MessageRetried: "MessageRetried",
    MessageRegenerated: "MessageRegenerated",
    MessageCancelled: "MessageCancelled",
    MessageCopied: "MessageCopied",
    InlineCitationClicked: "InlineCitationClicked",
    CitationPreviewed: "CitationPreviewed",
    CitationBookViewOpened: "CitationBookViewOpened",
} as const;

export const ToolCallEventActions = {
    ChecklistCreateFailed: "ChecklistCreateFailed",
    ChecklistCreateRetried: "ChecklistCreateRetried",
    ChecklistCreated: "ChecklistCreated",
    ChecklistCompleted: "ChecklistCompleted",
    ChecklistDismissed: "ChecklistDismissed",
} as const;

export type ConversationEventAction =
    (typeof ConversationEventActions)[keyof typeof ConversationEventActions];
export type MessageEventAction =
    (typeof MessageEventActions)[keyof typeof MessageEventActions];
export type ToolCallEventAction =
    (typeof ToolCallEventActions)[keyof typeof ToolCallEventActions];
